export default __webpack_public_path__ + "static/media/quiz.f1a1d978.png";